import { AxiosResponse } from 'axios';

import { instance as axios } from 'api/axios';

export class FillFieldsService {
  public static async getFields(url: string, params: object) {
    try {
      const response: AxiosResponse<any> = await axios.get(url, { params });

      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }
}
